import { fixedValues } from "./fixedValues";

export const isValidEmail = (email) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};

export const validatePassword = (password) => {
  const minLength = 8;
  const hasNumbers = /[0-9]/.test(password);
  const hasLetters = /[a-zA-Z]/.test(password);
  const noSpaces = !/\s/.test(password);

  if (password.length < minLength) {
    return "Password must be at least 8 characters long.";
  }
  if (!hasNumbers) {
    return "Password must contain at least one number.";
  }
  if (!hasLetters) {
    return "Password must contain at least one letter.";
  }
  if (!noSpaces) {
    return "Password must not contain spaces.";
  }
  return "";
};

export function isTokenExpired(expiryDate) {
  const expiry = new Date(expiryDate);
  const now = new Date();

  return now > expiry;
}

export function getUpcomingDate(day, hour, minute) {
  // Mapping of days to numbers (Sunday = 0, Monday = 1, ..., Saturday = 6)
  const dayMap = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  // Get today's date and the current day number
  const today = new Date();
  const currentDay = today.getDay();

  // Target day number
  const targetDay = dayMap[day.toLowerCase()];

  if (targetDay === undefined) {
    throw new Error(
      "Invalid day provided. Use a valid weekday (e.g., 'Monday')."
    );
  }

  // Calculate days until the next target day
  const daysUntilTarget = (targetDay - currentDay + 7) % 7 || 7;

  // Calculate the target date
  const targetDate = new Date(today);
  targetDate.setDate(today.getDate() + daysUntilTarget);

  // Set the time (hour and minute)
  targetDate.setHours(hour, minute, 0, 0);

  // Return in ISO format
  return targetDate.toISOString();
}

export function formatDate(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const formattedDate = `${day}.${month}.${year}`;

  return formattedDate;
}

export function getPlanString(clubbiePlus) {
  const source = clubbiePlus?.source;

  if (source === fixedValues.subscriptionMethods.MOBILE) {
    return fixedValues.mobileProductPlans[clubbiePlus?.subscription?.productId]
      ?.title;
  } else if (source === fixedValues.subscriptionMethods.WEB) {
    return `${clubbiePlus?.subscription?.title} / £${clubbiePlus?.subscription.amount}`;
  } else {
    return "Custom";
  }
}


export function sortByKey (array, key, order = 'desc') {
  return array.sort((a, b) =>
    order === 'desc' ? b[key] - a[key] : a[key] - b[key],
  );
};

export function formNumber (n, fixTo = 2) {
  const num = Number(n);
  if (isNaN(num) || [undefined, null].includes(num)) return 0;
  if (+num % 1 !== 0) {
    return num.toFixed(fixTo);
  }
  return num;
};